import { lazy, Suspense, useEffect } from 'react';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { Logout } from './store/actions/AuthActions';


const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./jsx/pages/ResetPassword'));
const Login = lazy(() => {
  return new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}



function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const userData = JSON.parse(localStorage.getItem('userDetails'))
  const userDataAll = JSON.parse(localStorage.getItem('userDetailsAll')) || {}
  useEffect(() => {
    if (location.pathname === '/login') {
      if (userData?.length > 0) {
        // Check if user has roomops role and redirect to monitor
        const roleName = userDataAll?.session_info?.role_name || ''
        const isRoomopsRole = roleName && (
          roleName.toLowerCase().includes('roomops') ||
          roleName.toLowerCase() === 'roomops monitor' ||
          roleName.toLowerCase() === 'roomops admin' ||
          roleName.toLowerCase() === 'roomops manager'
        )
        navigate(isRoomopsRole ? '/multi-property-monitor' : '/dashboard')
      }
    }
    checkAutoLogin(dispatch, navigate);

    // const tokenDetailsString = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : [];
    // if (tokenDetailsString?.length === 0) {
    //     dispatch(Logout('/login'));
    //     return;
    // }
  }, []);



  let routeblog = (

    <Routes>
      <Route path='/login' element={<Login />} />
      <Route path='/page-register' element={<SignUp />} />
      <Route path='/page-forgot-password' element={<ForgotPassword />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/page-reset-password' element={<ResetPassword />} />
      <Route path='/reset-password' element={<ResetPassword />} />
    </Routes>
  );
  if (props.isAuthenticated) {
    return (
      <>
        <Suspense fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
        >
          <Index />
        </Suspense>
      </>
    );

  } else {
    return (
      <div className="vh-100">
        <Suspense fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
        >
          {routeblog}
        </Suspense>
      </div>
    );
  }
};


const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

//export default connect((mapStateToProps)(App)); 
export default withRouter(connect(mapStateToProps)(App));

